import { FormHelperText, styled } from '@mui/material';

export const HelperText = styled(FormHelperText)<{
  color?: 'secondary' | 'primary';
}>(({ theme, color }) => ({
  color: color ? theme.palette[color].main : undefined,
}));
